/**
 * contactjs
 */
const contact = () => {
  const contactConfirm = document.querySelector('.mw_wp_form_confirm');
  const contactComplete = document.querySelector('.mw_wp_form_complete');
  const flowlist = document.querySelectorAll('.js-flow-item');

  if (contactConfirm && flowlist.length > 0) {
    flowlist.forEach(elementItem => {
      elementItem.classList.remove('active');
    });

    flowlist[1].classList.add('active');
  }

  if (contactComplete && flowlist.length > 0) {
    flowlist.forEach(elementItem => {
      elementItem.classList.remove('active');
    });

    flowlist[2].classList.add('active');
  }

  const agree = document.querySelector('.form__checkbox-mw')?.querySelector('.mwform-checkbox-field-text');
  if (agree) {
    agree.innerHTML = "<a href='/privacy-policy' target='__blank' class='contact__policy-link'>プライバシーポリシー</a>に同意する";
  }
};

export default contact;